import { ROLE } from "src/redux/TopBar/constants";
import { TopBarSelectors } from "src/redux/TopBar/selectors";
import { SettingsSelectors } from "src/redux/Settings/selectors";
import { createSelector } from "@reduxjs/toolkit";

const getCounterPartysAll = (state) => state.CounterPartys.all;
const getCounterPartysAllById = (state) => state.CounterPartys.allById;
const getCounterPartysError = (state) => state.CounterPartys.error;
const getRole = (state) => TopBarSelectors.Role(state);
const getFeatureFlags = (state) => SettingsSelectors.FeatureFlags(state);
const getOfferSettings = (state) => state.Tx.initiate.offerSettings;

export const CounterPartysSelectors = {
    SelectAll: createSelector(
        [getCounterPartysAll, getRole, getFeatureFlags, getOfferSettings],
        (all, role, featureFlags, offerSettings) => {
            const enabledUnregisteredLenderFeature =
                featureFlags["enables-unregistered-lender-feature"];
            // Spec §3 "Guest Lender: Disabled". Limited UI suppresses
            // unregistered cpties everywhere they'd otherwise be
            // pickable, regardless of the standalone
            // enables-unregistered-lender-feature flag. Backend also
            // rejects updatePeerCptys with isUnregistered=true under
            // limited-ui (SettingsController gate), so even if a stale
            // unregistered cpty exists in state it won't survive a
            // round-trip.
            const limitedUi = featureFlags["limited-ui"];

            return all
                .filter((i) => !i.myCpty)
                .filter((i) => {
                    if (limitedUi) {
                        return !i.unregistered;
                    }
                    if (
                        role === ROLE.BORROWER &&
                        enabledUnregisteredLenderFeature
                    ) {
                        return true;
                    } else {
                        return !i.unregistered;
                    }
                })
                .filter((i) => {
                    return offerSettings.type !== "HOLD" || !i.partner;
                });
        }
    ),

    GetAllRegisteredPeerCptys: createSelector(getCounterPartysAll, (all) =>
        all.filter((i) => !i.myCpty && !i.unregistered && !i.partner)
    ),

    GetAllCptysById: createSelector(
        getCounterPartysAllById,
        (allById) => allById
    ),

    GetMyCounterParty: createSelector(
        getCounterPartysAll,
        (all) => all.filter((i) => i.myCpty)[0] || {}
    ),

    Error: getCounterPartysError,

    Get: (state, id) => {
        const allById = getCounterPartysAllById(state);
        return allById[id];
    },

    IsPartnerCpty: (state, id) => {
        const allById = getCounterPartysAllById(state);
        return allById[id]?.partner === true;
    },
};
